import { render, staticRenderFns } from "./criteria-assessment.vue?vue&type=template&id=af485ab6&scoped=true&"
import script from "./criteria-assessment.vue?vue&type=script&lang=ts&"
export * from "./criteria-assessment.vue?vue&type=script&lang=ts&"
import style0 from "./criteria-assessment.vue?vue&type=style&index=0&id=af485ab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af485ab6",
  null
  
)

export default component.exports